import Layout from '@/layout';
// 行政
export default {
    path: '/administrative',
    redirect: '/administrative/organization',
    name: 'Administrative',
    component: Layout,
    alwaysShow: true,
    meta: {
        title: '行政',
        icon: 'menu_xz',
        modules: [12000]
    },
    children: [
        {
            path: 'organization',
            name: 'Organization',
            component: () => import('@/views/administrative/organization/index'),
            meta: {
                title: '组织架构',
                icon: 'spot',
                modules: [12005]
            }
        }
    ]
};
